import React from 'react';
import { ParticipantStep } from '../../../../../../types/v3Types';
import { FormQuiz, IFormHandleExtended } from '../../../components/FormQuiz';
import { SideBarStepView } from '../../../components/SideBarStepView';
import { StepViewBreadcrumbs } from '../../../components/StepViewBreadcrumbs';
import { StepViewHidden } from '../../../components/StepViewHidden';
import { getTitle } from '../../../../../../selectors/step';
import { isSectionLockedForStep } from '../../utils';
import { sidebarLayoutDataHooks } from '../sidebarLayoutDataHooks';
import { Props } from '../interfaces';

export interface StepViewProps {
  props: Props;
  currentStep: ParticipantStep | null;
  goToMobileList: () => void;
  getQuizData: () => any;
  resolveQuiz: (quizSubmissionId?: string) => Promise<void>;
  formQuizRef: React.RefObject<IFormHandleExtended>;
}

export const StepView: React.FC<StepViewProps> = ({
  props,
  currentStep,
  goToMobileList,
  getQuizData,
  resolveQuiz,
  formQuizRef,
}) => {
  const {
    challengeData: { challenge },
    isListParticipantSectionsRequestInProgress,
    listParticipantSections,
    isParticipantStepsLoading,
    participantSteps,
    isParticipantInSuspendedState,
    isParticipantInLockedState,
  } = props;

  const quizData = getQuizData();
  const isParticipantInNegativeState =
    isParticipantInSuspendedState || isParticipantInLockedState;

  if (isParticipantInNegativeState) {
    return null;
  }

  const { isSectionLocked, waitingStart } = isSectionLockedForStep(
    currentStep,
    listParticipantSections,
  );

  if (isSectionLocked) {
    return (
      <div data-hook={sidebarLayoutDataHooks.stepViewWrapper()}>
        <StepViewHidden
          date={waitingStart}
          goToCurrentStep={() => {
            // This would need to be passed down as a prop
          }}
          titleKey="live.section.section-locked.title"
          descriptionKey="live.challenges-page.hidden-step.description-scheduled"
        />
      </div>
    );
  }

  return (
    <div data-hook={sidebarLayoutDataHooks.stepViewWrapper()}>
      {quizData.isQuiz ? (
        <FormQuiz
          key={`form-quiz-${quizData.formId}`}
          formId={quizData.formId}
          submissionId={quizData.quizSubmissionId}
          onResolve={(lastSubmissionId: string) => {
            void resolveQuiz(lastSubmissionId);
          }}
          stepName={getTitle(currentStep?.source)}
          Breadcrumbs={() => (
            <StepViewBreadcrumbs goToMobileList={goToMobileList} />
          )}
          ref={formQuizRef}
        />
      ) : (
        <SideBarStepView
          dataHook={sidebarLayoutDataHooks.stepView()}
          participantSteps={participantSteps}
          listParticipantSections={listParticipantSections}
          challenge={challenge}
          isListParticipantSectionsRequestInProgress={
            isListParticipantSectionsRequestInProgress
          }
          goToCurrentStep={() => {
            // This would need to be passed down as a prop
          }}
          isParticipantStepsLoading={isParticipantStepsLoading}
          currentStep={currentStep}
          Breadcrumbs={() => (
            <StepViewBreadcrumbs goToMobileList={goToMobileList} />
          )}
          pageRef={props.pageRef}
        />
      )}
    </div>
  );
};
